module.exports = __webpack_public_path__ + "static/img/backg12.2229a758.png";